import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { canSeeV2Links, useCurrentUser } from '../../utils/CurrentUserContext';
import { trackEvent } from '../../utils/analytics';
import { getV2Destination } from '../../utils/v2Routes';
import OpenInV2Link from './OpenInV2Link';
import WhatsChangingDrawer from './WhatsChangingDrawer';

const DRAWER_ID = 'v2-whats-changing-drawer';

// Persistent, non-dismissible V2 beta strip shown below the top navigation.
// Visibility (the "showV2BetaStrip" flag) follows the company's v2migration setting.
export default function V2BetaStrip() {
  const { user } = useCurrentUser();
  const { pathname } = useLocation();
  const [drawerOpen, setDrawerOpen] = useState(false);

  if (!canSeeV2Links(user)) {
    return null;
  }

  const destination = getV2Destination(pathname, user.companyId);

  const openDrawer = () => {
    trackEvent('v2_whats_changing_opened', { source: 'v2_strip', fromRoute: destination.matchedPattern });
    setDrawerOpen(true);
  };

  return (
    <div className="sticky top-0 z-30 border-t border-[#E0E7FF] bg-[#EEF2FF] py-2">
      {/* Same content width as TopNavigation */}
      <div className="mx-auto flex max-w-7xl flex-wrap items-center gap-4 px-4 sm:px-6 lg:px-8">
        <p className="flex min-w-[240px] flex-1 flex-wrap items-center gap-1.5 text-sm text-[#312E81]">
          <strong className="font-semibold">V2</strong>
          <span className="rounded-full bg-[#4F46E5] px-2 py-0.5 text-[11px] font-semibold leading-4 text-white">
            β
          </span>
          <span>
            <strong className="font-semibold">is here</strong> — clearer performance overviews, flexible budget limits,
            video in content and outcome-based optimisation.
          </span>
        </p>
        <button
          type="button"
          onClick={openDrawer}
          aria-expanded={drawerOpen}
          aria-controls={DRAWER_ID}
          aria-haspopup="dialog"
          className="inline-flex h-8 flex-shrink-0 items-center whitespace-nowrap rounded-md border border-[#C7D2FE] bg-white px-3 text-sm text-[#3730A3] hover:bg-[#F5F7FF] focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2"
        >
          What's changing
        </button>
        <OpenInV2Link destination={destination} source="v2_strip" />
      </div>
      <WhatsChangingDrawer
        id={DRAWER_ID}
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        destination={destination}
      />
    </div>
  );
}
